import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgSaderat = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='#29166F'
      d='M1 1.001h7.194v10.216c.119-.455.297-.897.561-1.288a3.96 3.96 0 0 1 1.73-1.437 3.9 3.9 0 0 1 3.67.338 3.9 3.9 0 0 1 1.664 2.411c.011-1.94 0-3.88.005-5.82-.006-.267.011-.536-.008-.8-.159-.607-.443-1.194-.877-1.652-.51-.546-1.239-.847-1.972-.927-.521-.066-1.045-.026-1.564.03 1.238-.608 2.6-.94 3.973-1.04.588-.052 1.178-.023 1.766-.03a5.78 5.78 0 0 1 4.107 1.665 5.8 5.8 0 0 1 1.72 3.515c.043.325.028.654.03.981V23h-7.176v-5.92c-.005-1.376.008-2.75-.008-4.126-.277 1.326-1.315 2.452-2.602 2.863a3.905 3.905 0 0 1-4.373-1.434 4 4 0 0 1-.646-1.42v5.893c.005.178-.011.358.006.536.143.522.371 1.024.71 1.447.39.496.954.843 1.56 1.007.64.174 1.316.177 1.97.091l.065.047c-.5.22-1.008.432-1.538.573-.808.23-1.639.37-2.478.42-.521.039-1.042.014-1.564.02a5.78 5.78 0 0 1-3.71-1.264 5.85 5.85 0 0 1-1.9-2.696 5.7 5.7 0 0 1-.28-1.328c-.047-.627-.03-1.253-.033-1.88V1.002z'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgSaderat)
export default ForwardRef
